import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface GuardRailListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class GuardRailListPage extends Component<GuardRailListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.guard_rail.list }}
                pages={{
                    entity: InferenceEntities.guard_rail(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}